<template>
  <!-- KPI ROW -->
  <div class="stats-container">
    <div class="stat-item" v-for="(stat, index) in statsData" :key="index">
      <StatCard
        :label="stat.label"
        :value="stat.value"
        :meta="stat.meta"
        :gradient="stat.gradient"
        :chart="stat.chart"
        :valFormat="stat.valFormat"
      />
    </div>
  </div>
</template>

<script>
import StatCard from './StatCard.vue'
import axios from  'axios'
import {URL} from '../../../env'

export default {
  components: {
    StatCard
  },
  data () {
    return {
      statsResp: {},
    }
  },
  computed: {
    statsData() {
      const declinedPercentage = this.statsResp.total_submissions > 0 
        ? ((this.statsResp.total_declined || 0) / this.statsResp.total_submissions * 100).toFixed(2) + '%'
        : '0%';

      const offerSentPercentage = this.statsResp.total_submissions > 0 
        ? ((this.statsResp.total_offer || 0) / this.statsResp.total_submissions * 100).toFixed(2) + '%'
        : '0%';

      const contractSentPercentage = this.statsResp.total_submissions > 0 
        ? ((this.statsResp.total_contract_sent || 0) / this.statsResp.total_submissions * 100).toFixed(2) + '%'
        : '0%';

      return [
        {
          label: 'Total Submissions',
          value: this.statsResp.total_submissions || '0',
          meta: 'Last 30 days',
          gradient: 'linear-gradient(90deg, #0b63ce, #1f7ae0)',
          chart: '',
          valFormat: 'number'
        },
        {
          label: 'Offers Sent',
          value: this.statsResp.total_offer || '0',
          meta: `${offerSentPercentage} of submissions`,
          gradient: 'linear-gradient(90deg, #7c3aed, #c084fc)',
          chart: '',
          valFormat: 'number'
        },
        {
          label: 'Contract Sent/Signed',
          value: this.statsResp.total_contract_sent || '0',
          meta: `${contractSentPercentage} of submissions`,
          gradient: 'linear-gradient(90deg, #0f766e, #2dd4bf)',
          chart: '',
          valFormat: 'number'
        },
        {
          label: 'Declines',
          value: this.statsResp.total_declined || '0',
          meta: `${declinedPercentage} of submissions`,
          gradient: 'linear-gradient(90deg, #f97316, #fdba74)',
          chart: '',
          valFormat: 'number'
        },
        {
          label: 'Funded Volume',
          value: this.statsResp.total_funded_amount || 0,
          meta: `${this.statsResp.total_funded || '0'} deals funded`,
          gradient: 'linear-gradient(90deg, #059669, #34d399)',
          chart: '',
          valFormat: 'currency'
        }
      ]
    }
  },
  mounted(){
    this.getStatsData();
  },
  methods: {
    getStatsData() {
      const isoId = localStorage.getItem("iso_id");
      axios.get(`${URL}/api/submission/isoportal_subs_counts/${isoId}`)
        .then(res => {
          this.statsResp = res.data;
        })
    },
  }
}
</script>

<style scoped>
.stats-container {
  display: flex;
  width: 100%;
  gap: 8px;
  margin-bottom: 16px;
}

.stat-item {
  flex: 1;
  min-width: 0; /* Prevents flex items from overflowing */
}

/* Responsive behavior */
@media (max-width: 768px) {
  .stats-container {
    flex-direction: column;
  }
  
  .stat-item {
    margin-bottom: 8px;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .stats-container {
    flex-wrap: wrap;
  }
  
  .stat-item {
    flex: 0 0 calc(50% - 4px);
  }
}
</style>
